// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__au5x6","innerSpinner":"LoadingSpinner_innerSpinner__o7Jf+"};